import styled from '@emotion/styled';
import { theme } from '../../theme';
export const StyledListItem = styled.li `
	list-style: none;
	display: grid;
	grid-template-columns: auto 1fr;
	padding: ${theme.spacing.space40} ${props => props.compact ? theme.spacing.space40 : theme.spacing.space50};
	position: relative;
	transition: background-color 120ms, border 120ms ease-in-out;
	gap: ${theme.spacing.space20};

	&:not(:first-of-type):before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		height: 1px;
		background-color: ${theme.colors.LM_NU30T};
	}
	&:hover, :focus {
		${props => props.onClick && `
			&:before {
				height: 0 !important;
			}
			+ li {
				&:before {
					height: 0 !important;
				}
			}
		`}
	}

	${props => props.rounded && `
		border-radius: ${theme.spacing.space30};
		&:not(:first-of-type):before {
			left: unset;
			width: calc(100% - ${12 * 2}px); // default border radius is 12px
		}
	`};

	${props => !props.rounded && `
		&:not(:first-of-type):before {
			width: 100%;
		}
	`};

	&:focus {
		background-color: ${theme.colors.LM_NU30T};
		outline: 2px solid ${theme.colors.LM_NU60};
		z-index: 1; // brings outline to front when siblings are selected state
		outline-offset: -2px;

		.list-item-label {
			color: ${theme.colors.typography.heading};
		}
		.list-item-description {
			color: ${theme.colors.typography.body};
		}
	}

	${props => props.disabled && 'opacity: 20%;'};
	${props => props.onClick && !props.disabled && `
		cursor: pointer;
		&:hover {
			background-color: ${!props.selected ? theme.colors.LM_NU20T : theme.colors.BB120};
		}
	`};

	${props => !!props.selected && `
		background-color: ${theme.colors.BB100};
		color: white;
		&:focus {
			background-color: ${theme.colors.BB120};
			outline: 2px solid ${theme.colors.BB80};
			outline-offset: -2px;
			z-index: 1; // brings outline to front when siblings are selected state
			.list-item-label {
				color: white;
			}
			.list-item-description {
				color: white;
			}
		}
		&:before {
			height: 0 !important;
		}
		+ li {
			&:before {
				height: 0 !important;
			}
		}
	`};
`;
export const StyledImage = styled.img `
	width: 48px;
	height: 48px;
	border-radius: 8px;
`;
export const StyledContentWrapper = styled.div `
	flex-grow: 1;
`;
export const StyledLabelWrapper = styled.div `
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: ${theme.spacing.space20};
`;
export const StyledLabel = styled.span `
	font-family: ${theme.typography.IB100.fontFamily};
	font-size: ${theme.typography.IB100.fontSize};
	font-weight: ${theme.typography.IB100.fontWeight};
	line-height: ${theme.typography.lineHeight.md};
	color: ${props => props.selected ? 'white' : theme.colors.typography.heading};

	word-break: break-word;
`;
export const StyledDescription = styled.span `
	font-family: ${theme.typography.IR90.fontFamily};
	font-size: ${theme.typography.IR90.fontSize};
	font-weight: ${theme.typography.IR90.fontWeight};
	line-height: ${theme.typography.lineHeight.md};
	color: ${props => props.selected ? 'white' : theme.colors.typography.body};
`;
export const ChildrenContainer = styled.div `
	grid-column: 1 / span 2;
`;
//# sourceMappingURL=ListItem.styled.js.map